module.exports = __webpack_public_path__ + "img/XLS_document_icon@2x.f417fe03.png";